export default "__VITE_ASSET__BTXmc9kd__"